import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { PageShell } from '../components/PageShell';
import { SectionHeading } from '../components/SectionHeading';
import { engagementTypes, industryExperience, regulatoryEnvironments } from '../data/profile';
export function Experiences() {
  return <PageShell path="/experiences" data-id="element-310" data-mp="2d4dg35mcvn7i">
      <section className="bg-white py-20 lg:py-24" aria-labelledby="industry-heading" data-id="element-311" data-mp="2d5eyxw9m5dzs">
        <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-312" data-mp="30vsj70lyi8jt">
          <div id="industry-heading" data-id="element-313" data-mp="35u3u7enzmp3m">
            <SectionHeading eyebrow="Industry Exposure" title="Where she has operated" description="Four sectors, each with a different definition of what an unacceptable data failure looks like." data-id="element-314" data-mp="35t2id7z5dyku" />
          </div>

          <ul className="mt-12 grid grid-cols-1 gap-px border border-platinum-200 bg-platinum-200 md:grid-cols-2" data-id="element-315" data-mp="3jt3hahvuqvxo">
            {industryExperience.map(industry => <li key={industry.sector} className="flex flex-col bg-white p-8 lg:p-10" data-id="element-316" data-mp="3v0zgnr8rk5yn">
                <p className="font-sans text-xs font-semibold uppercase tracking-[0.16em] text-gold-600" data-id="element-317" data-mp="3uymybcz3ftl2">
                  {industry.years}
                </p>
                <h3 className="mt-3 font-display text-xl font-bold leading-snug tracking-tight text-navy-900" data-id="element-318" data-mp="8m6l8wgq1tym">
                  {industry.sector}
                </h3>
                <p className="mt-4 font-sans text-sm leading-relaxed text-charcoal-600" data-id="element-319" data-mp="hljvhrco6mke">
                  {industry.focus}
                </p>
                <ul className="mt-auto flex flex-wrap gap-2 pt-6" data-id="element-320" data-mp="dk84bhe5dta3">
                  {industry.exposure.map(item => <li key={item} className="whitespace-nowrap border border-platinum-200 bg-platinum-100 px-2.5 py-1 font-sans text-xs font-semibold text-charcoal-700" data-id="element-321" data-mp="rhwo0lwhaudk">
                      {item}
                    </li>)}
                </ul>
              </li>)}
          </ul>
        </div>
      </section>

      <section className="bg-navy-900 py-20 lg:py-24" aria-labelledby="regulatory-heading" data-id="element-322" data-mp="x8hhw41g4oaj">
        <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-14 px-6 lg:grid-cols-12 lg:gap-16 lg:px-10" data-id="element-323" data-mp="xac2ticpwgem">
          <div className="lg:col-span-5" data-id="element-324" data-mp="168xjf7ymplcr">
            <div id="regulatory-heading" data-id="element-325" data-mp="169ytpa7tm3tf">
              <SectionHeading eyebrow="Regulatory Environments" title="Supervisory regimes worked within" description="Direct accountability for evidence and remediation under each of the following." tone="dark" data-id="element-326" data-mp="166t8i62bbm2z" />
            </div>
          </div>

          <ul className="space-y-px bg-white/10 lg:col-span-7" data-id="element-327" data-mp="1p06rdcsr4228">
            {regulatoryEnvironments.map(regulator => <li key={regulator.name} className="flex items-start gap-5 bg-navy-900 py-6" data-id="element-328" data-mp="1u02y3jsu27lh">
                <ShieldCheckIcon className="mt-1 h-5 w-5 shrink-0 text-gold-400" aria-hidden="true" data-id="element-329" data-mp="1yywblc84dyln" />
                <div data-id="element-330" data-mp="292t60ewqq96o">
                  <p className="font-display text-base font-bold text-white" data-id="element-331" data-mp="29330ofsqd4ip">{regulator.name}</p>
                  <p className="mt-2 font-sans text-sm leading-relaxed text-platinum-300" data-id="element-332" data-mp="2413yvacn2fnv">
                    {regulator.detail}
                  </p>
                </div>
              </li>)}
          </ul>
        </div>
      </section>

      <section className="bg-platinum-100 py-20 lg:py-24" aria-labelledby="engagement-heading" data-id="element-333" data-mp="2rrzs8bwqtix8">
        <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-334" data-mp="2mtga6ml9sra5">
          <div id="engagement-heading" data-id="element-335" data-mp="2mv9g1zo277h3">
            <SectionHeading eyebrow="Engagement Types" title="The shapes of work she has led" data-id="element-336" data-mp="2i1y4jl8ay2iu" />
          </div>
          <ul className="mt-10 grid grid-cols-1 gap-px border border-platinum-200 bg-platinum-200 sm:grid-cols-2 lg:grid-cols-3" data-id="element-337" data-mp="2e0mfbgtcbjb6">
            {engagementTypes.map(type => <li key={type} className="bg-white px-6 py-7 font-display text-base font-semibold leading-snug text-navy-900" data-id="element-338" data-mp="35r91ermj7crp">
                {type}
              </li>)}
          </ul>
        </div>
      </section>
    </PageShell>;
}